import React, {useState, useEffect} from 'react';
import {
  Text,
  View,
  StyleSheet,
  TouchableOpacity,
  Dimensions,
} from 'react-native';
import HomeHeader from '../../components/HomeHeader';
import {getCartItems} from '../../database/DataBase';
import BasePackListComponent from './BasePackListComponent';
import AddOnsListComponent from './AddOnsListComponent';
import AlaCarteListComponent from './AlaCarteListComponent';
import CheckoutFooter from '../../components/CheckoutFooter';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;
const isWeb = WIDTH > 992;

export default function SelectPack(props) {

  const [cart, setCart] = useState([]);
  const [selectedBouques, setSelectedBouques] = useState([]);
  const [tab, setTab] = useState('add_ons');
  const [isCartUpdated, setIsCartUpdated] = useState(false);
  
  useEffect(() => {
    getCartItems()
      .then((items) => {
        setIsCartUpdated(true);
        if(Array.isArray(items)){
          const ids = [];
          items.forEach((obj) => {
            ids.push(obj.id);
          });
          setSelectedBouques(ids);
          setCart(items);
        }
      });
  },[]);

  const addToCart = (item) => {
    setCart([...cart, item]);
    setSelectedBouques([...selectedBouques, item.id]);
  }

  const removeFromCart = (itemId) => {
    let copy = [...cart];
    let index = 0;
    let myIndex = -1;
    copy.map((obj) => {
      if(obj.id == itemId){
        myIndex = index;
      }
      index++;
    });
    copy.splice(myIndex, 1);
    setCart(copy);
    const ids = [...selectedBouques];
    if(ids.includes(itemId)){
      ids.splice(ids.indexOf(itemId), 1);
      setSelectedBouques(ids);
    }
  }

  return (
    <View style={styles.container}>
      <HomeHeader navigation={props.navigation}/>
      <View style={styles.tabs}>
        {/* <TouchableOpacity
          onPress={() => setTab('base_packs')}
          style={tab === 'base_packs' && styles.activeTab}>
          <Text style={styles.tabHeader}>Base Packs</Text>
        </TouchableOpacity> */}
        <TouchableOpacity
          onPress={() => setTab('add_ons')}
          style={tab === 'add_ons' && styles.activeTab}>
          <Text style={styles.tabHeader}>Add ons</Text>
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => setTab('ala_carte') }
          style={tab === 'ala_carte' && styles.activeTab}>
          <Text style={styles.tabHeader}>À la carte</Text>
        </TouchableOpacity>
      </View>
      <View style={styles.content}>
        {tab === 'base_packs' && <BasePackListComponent addToCart={addToCart} removeFromCart={removeFromCart}/>}
        {tab === 'add_ons' && <AddOnsListComponent addToCart={addToCart} removeFromCart={removeFromCart} cartItems={selectedBouques}/>}
        {tab === 'ala_carte' && <AlaCarteListComponent addToCart={addToCart} removeFromCart={removeFromCart} cartItems={selectedBouques}/>}
        <CheckoutFooter
          show={cart.length > 0}
          cartItems={cart}
          isCartUpdated={isCartUpdated}
          periodId={'2'}/>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    marginHorizontal: isWeb ? 64 : 16,
    marginTop: 32,
    marginBottom: 128
  },
  activeTab: {
    borderBottomColor: '#fd6060',
    paddingBottom: 18,
    borderBottomWidth: isWeb ? 3 : 2,
  },
  tabs: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    marginHorizontal: isWeb ? 64 : 16,
    borderBottomWidth: 1,
    borderColor: '#ccccccb0',
    marginTop: 16,
  },
  tabHeader: {
    paddingHorizontal: 10,
    color: '#0092ed',
    fontWeight: 'bold',
    letterSpacing: 1,
    fontSize: isWeb ? 15 : 13,
  },
});
  